<template>
  <div class="TestPriceResult" v-title data-title="水产价格测算结果">
    <van-circle v-if="result.lt || result.lt == 0"
      v-model="current"
      :rate="result.lt"
      :speed="100"
      size="55vw"
      color="#2027ac"
      layer-color="#cde4f7"
      fill="ffffff"
      stroke-linecap="butt"
      :clockwise="false">
      <div class="circle-text">
        {{result.lt || 0}}%
      </div>
    </van-circle>
    <div class="fc-suppl pt10 fs7">恭喜您！</div>
    <div class="fc-suppl fs7">您的销售价{{params.price||0}}元打败了{{result.lt||0}}%用户</div>
    <div class="padding10 fs4">
      <table>
        <tr>
          <td>
            销售价<br>&lt;{{params.price}}
          </td>
          <td>
            销售价<br>{{params.price}}
          </td>
          <td>
            销售价<br>&gt;{{params.price}}
          </td>
        </tr>
        <tr>
          <td>{{result.lt||0}}%</td>
          <td>{{result.eq||0}}%</td>
          <td>{{result.gt||0}}%</td>
        </tr>
      </table>
    </div>
    <div class="row justify-content-around mt7 pl7 pr7">
      <van-button type="info" @click="back" class="btn-primary">返 回</van-button>
    </div>
    <!-- <div class="copyright bc-copyright">
      <a style="color: #c1c1c1;" target="_blank" href="http://beian.miit.gov.cn">沪ICP备19025713号-1</a>
    </div> -->
  </div>
</template>

<script>
import Vue from 'vue';
import { sendRequest, quotesCheck } from '../../network/NetworkAccessor';
// import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'TestPriceResult',
  components: { },
  data() {
    return {
      current: 0,
      params: {},
      result: {
        gt: 23,
      },
    };
  },
  props: {
    pm: {
      type: String,
      default: null,
    },
  },
  computed: {
  },
  methods: {
    quotesCheck() {
      sendRequest(quotesCheck, this.params).then((res = {}) => {
        this.result = res || {};
      }).catch((e) => {
        // this.$dialog.alert({
        //   message: e.message,
        // });
      });
    },
    back() {
      this.$router.replace('/test/price/home');
    },
  },
  created() {
    this.params = Object.assign(this.params, JSON.parse(this.pm));
    this.quotesCheck();
  },
});
</script>
<style scoped>
  .TestPriceResult {
    min-height: 100vh;
    background-color: #e7e6ff;
    padding-top: 10vh;
  }
  .circle-text {
    position: absolute;
    top: 50%;
    text-align: center;
    width: 100%;
    transform: translateY(-50%);
    font-weight: bold;
    color: #2027ac;
    font-size: 30px;
  }
  table {
    width: 100%;
    border-spacing: 0;
    border: 2px solid #ffffff;
    color: #2027ac;
    font-weight: bold;
  }
  table td {
    border: 1px solid #ffffff;
    height: 60px;
  }
</style>
